import * as d3 from "d3";

export interface ColourAction 
{
    element: d3.Selection<SVGElement, unknown, null, undefined>;
    color: string;
    parents?: Array<string>;
}

export class ColourIn
{
    private svg: d3.Selection<SVGSVGElement, unknown, null, undefined>;
    private g: d3.Selection<SVGGElement, unknown, null, undefined>;
    private image: d3.Selection<SVGGElement, unknown, null, undefined> | null;

    private selectedColourFill: string = "#000";
    private colourActions: Array<ColourAction> = [];

    private loadedImage: HTMLImageElement;

    constructor(private container: HTMLDivElement, private imgSrc: string)
    {
        this.loadedImage = document.createElement("img") as HTMLImageElement;
        this.loadedImage.onload = this.onImageReady.bind(this);
        this.loadedImage.src = imgSrc;
    }

    private onImageReady(): void 
    {
        this.init();
    }

    private zoom: any;
    private init(): void 
    {
        this.svg = d3.select(this.container)
            .append("svg")
            .attr("width", "100%")
            .attr("height", "100%");



        this.g = this.svg.append("g");
        this.image = null;

        this.zoom = d3.zoom()
            .scaleExtent([1, 2])
            .translateExtent([[0, 0], [this.container.clientWidth, this.container.clientHeight]])
            .on("zoom", this.handleZoom.bind(this));

        this.svg.call(this.zoom);

        this.loadSVG();
    }

    private onSvgClicked(e: MouseEvent): void 
    {
        console.log("Clicked", e);
        // @ts-ignore
        const target = d3.select(e.target);
        this.changeColor(target);
    }

    public setColour(colour: string): void 
    {
        this.selectedColourFill = colour;
    }

    private basketIds: Array<string> = [
        "Basket",
        "BasketInner",
        "BasketGroup",
        "BasketShape"
    ];

    public undo(): void 
    {
        if (this.colourActions.length > 0)
        {
            const lastChange = this.colourActions.pop();
            const parents = lastChange.parents;
            if (parents)
            {
                parents.map(id =>
                {
                    let el = d3.select("#" + id);
                    console.log(el);
                    el.attr("style", "");
                });
            }

            if (lastChange.element)
            {
                lastChange.element.style("fill", lastChange.color);
            }
        }
    }

    private changeColor(element: any)
    {
        let node = element.node();
        console.log(node);

        if (node.nodeName === "svg")
        {
            console.log("Svg", node);
            return;
        }

        let parentId = "";
        try
        {
            parentId = node.parentNode.id;
        }
        catch {
        }

        const currentColor = element.style("fill");

        if (this.basketIds.indexOf(parentId) > -1)
        {
            // Also track these elements
            // console.log("Basket parent", node.parentNode);
            try
            {
                if (node.parentNode)
                {
                    this.basketIds.map(id =>
                    {
                        let el = d3.select("#" + id);
                        // @ts-ignore
                        // console.log(el);

                        el.style("fill", this.selectedColourFill);

                        this.colourActions.push({
                            element,
                            color: currentColor,
                            parents: this.basketIds
                        });

                        return;
                    })
                }
            }
            catch (e)
            {
                // console.warn("error", e);
            }
        }
        else 
        {
            element.style("fill", this.selectedColourFill);
            this.colourActions.push({ element, color: currentColor });
        }

    }

    public download(): void 
    {
        this.svg.call(this.zoom.transform, d3.zoomIdentity);

        let width = 584;
        let height = 740;

        this.svg
            .attr("width", width + "px")
            .attr("height", height + "px");

        let svgElement = this.svg.node();

        if (svgElement)
        {
            const svgData = new XMLSerializer().serializeToString(svgElement);

            // Reset
            this.svg
                .attr("width", "100%")
                .attr("height", "100%");

            this.svg.call(this.zoom.transform, d3.zoomIdentity);

            const img = new Image();
            img.setAttribute("width", width + "px");
            img.setAttribute("height", height + "px");

            img.onload = () => 
            {
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;

                const context = canvas.getContext("2d");
                context.drawImage(img, 0, 0);

                canvas.toBlob((blob) =>
                {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = "scene.jpg";
                    link.click();


                    URL.revokeObjectURL(url);
                }, "image/jpeg");
            };

            img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData)));
        }
    }

    private handleZoom(e: d3.D3ZoomEvent<SVGSVGElement, unknown>): void 
    {
        // @ts-ignore
        this.g.attr("transform", e.transform);
    }

    private loadSVG(): void
    {
        d3.svg(this.loadedImage.src).then((data) =>
        {
            this.image = this.g.append("g");

            const imageNode = this.image.node();

            if (imageNode)
            {
                const imageElement = d3.select(imageNode);

                imageElement.html(data.documentElement.outerHTML);

                console.log(this.svg.selectAll("path"));
                this.svg.selectAll("path").on("click", this.onSvgClicked.bind(this));
            }
        });
    }
}